<template>
  <TableComp
    :headers="headers"
    :name="$t('global.allocations')"
    :status="status"
    :number-of-items="allocations.length"
  >
    <template #desktop>
      <TableRow v-for="allocation in allocations" :key="allocation.id">
        <td class="align-middle">
          <router-link
            :to="{
              name: 'allocation-detail',
              params: { dedicatedServerId: serverId, allocationId: allocation.id },
            }"
          >
            {{ allocation.hostname }}
          </router-link>
        </td>
        <td class="align-middle text-center">
          {{ allocation.mainIp }} <CopyToClipboard :text="allocation.mainIp" />
        </td>
        <td class="align-middle text-center">
          <Pill
            :content="$t(`global.${allocation.powerStatus}`)"
            :variant="getStatusVariant(allocation.powerStatus)"
          />
        </td>
        <td class="align-middle text-center">
          <Pill
            :content="$t(`global.${allocation.powerStatus}`)"
            :variant="getStatusVariant(allocation.linkStatus)"
          />
        </td>
      </TableRow>
    </template>
    <template #mobile>
      <TableMobileRow v-for="allocation in allocations" v-bind:key="allocation.id">
        <template #header>
          <router-link
            :to="{
              name: 'allocation-detail',
              params: { dedicatedServerId: serverId, allocationId: allocation.id },
            }"
          >
            {{ allocation.hostname }}
          </router-link>
        </template>

        <template #content>
          <div class="row">
            <div class="col">{{ $t("global.main-ip") }}:</div>
            <div class="col">
              {{ allocation.mainIp }} <CopyToClipboard :text="allocation.mainIp" />
            </div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.power-status") }}:</div>
            <div class="col">
              <Pill
                :content="$t(`global.${allocation.powerStatus}`)"
                :variant="getStatusVariant(allocation.powerStatus)"
              />
            </div>
          </div>
          <div class="row">
            <div class="col">{{ $t("global.link-status") }}:</div>
            <div class="col">
              <Pill
                :content="$t(`global.${allocation.linkStatus}`)"
                :variant="getStatusVariant(allocation.linkStatus)"
              />
            </div>
          </div>
        </template>
      </TableMobileRow>
    </template>
  </TableComp>
</template>

<script>
import CopyToClipboard from "@/components/display/CopyToClipboard";
import { getStatusVariant } from "@/utils/statusVariant";
import Pill from "@/components/display/Pill";
import Status from "@/classes/Status";
import TableComp from "@/components/display/table/TableComp";
import TableHeader from "@/classes/TableHeader";
import TableMobileRow from "@/components/display/table/TableMobileRow";
import TableRow from "@/components/display/table/TableRow";

export default {
  name: "ServerAddonsTable",
  props: {
    allocations: Array,
    serverId: [Number, String],
  },
  components: {
    CopyToClipboard,
    Pill,
    TableComp,
    TableMobileRow,
    TableRow,
  },
  setup(props, { root }) {
    const status = new Status(Status.LOADED);
    const headers = [
      new TableHeader(root.$t("global.hostname")),
      new TableHeader(root.$t("global.main-ip"), "justify-content-center"),
      new TableHeader(root.$t("global.power-status"), "justify-content-center"),
      new TableHeader(root.$t("global.link-status"), "justify-content-center"),
    ];

    return {
      getStatusVariant,
      headers,
      status,
    };
  },
};
</script>
